(() => {
  const popup_close = document.querySelectorAll('[data-js-popup-name="leprojet_15"], .popup-leprojet .account__close');
  if(popup_close) {
    popup_close.forEach(close => {
      close.addEventListener('click', (el) => {
        setTimeout(() => {
          if(el.target.dataset.jsPopupName === 'leprojet_15' && !el.target.classList.contains('visible') || 
            el.target.closest('[data-js-popup-name="leprojet_15"]') && 
            !el.target.closest('[data-js-popup-name="leprojet_15"]').classList.contains('visible')) {
            const audio_pause = document.querySelectorAll('.audio-button.pause');
            audio_pause && audio_pause.forEach(btn => {
              btn.click();
            })
          }
        }, 500);
      })
    })
  }
})();